import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const MobileAppPentesting = () => {
    const navigate = useNavigate();

    // For demonstration, all Learn More buttons redirect to Google.
    // Replace with your own paths or logic as needed.
    const handleNavigation = (path) => {
        navigate('/contact');
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Mobile App Pentesting</h1>
                        <p className="tagline">
                            Protect your mobile applications with our in-depth penetration testing and expert analysis.
                        </p>
                    </header>

                    <section className="introduction">
                        <p>
                            In today's fast-paced mobile-first world, securing your mobile applications is crucial. Our Mobile App Pentesting service provides a comprehensive evaluation of your Android, iOS, and hybrid applications to identify vulnerabilities, ensuring your app remains robust against evolving threats.
                        </p>
                    </section>

                    <section className="why-choose-us">
                        <h2>Why Choose Our Mobile App Pentesting?</h2>
                        <p>
                        Assessing the security of mobile applications in this mobile-first, fast-paced world-really tends to matter. With our Bootstrapping Mobile App Pentesting, we provide the end-to-end evaluation of your Mobile apps (Android, iOS, Hybrid) to avoid the attack surface area and keep your applications resilient against changing dynamics.
                        </p>
                    </section>

                    <section className="tech-stack">
                        <h2>Our Testing Methodology & Tools</h2>
                        <p>
                            We combine automated scanning with meticulous manual testing to uncover vulnerabilities:
                        </p>
                        <ul>
                            <li><strong>Static & Dynamic Analysis:</strong> Assessing code quality and runtime behavior.</li>
                            <li><strong>Network Traffic Analysis:</strong> Monitoring data flow and identifying insecure communications.</li>
                            <li><strong>Reverse Engineering:</strong> Examining app binaries for hidden vulnerabilities.</li>
                            <li><strong>Industry Standards:</strong> Following OWASP Mobile Security Testing Guide and NIST guidelines.</li>
                        </ul>
                    </section>

                    <section className="secure-practices">
                        <h2>Our Approach & Best Practices</h2>
                        <p>
                        We are a confidential group of teams that will do proper testing on your mobile applications. Our testing procedure will encompass pre-assessment arrangements, comprehensive vulnerability discovery, and post-assessment assistance with regard to security improvements that best fit your business needs. 
                        </p>
                    </section>

                    <section className="services">
                        <h2>Our Mobile App Pentesting Services</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Android App Testing</h3>
                                <p>
                                    Evaluate your Android applications for vulnerabilities using advanced static and dynamic testing methods.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/android-pentest')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>iOS App Testing</h3>
                                <p>
                                    Secure your iOS applications through rigorous testing to detect weaknesses and ensure data protection.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/ios-pentest')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Hybrid App Testing</h3>
                                <p>
                                    Combine the best practices of native and web testing to ensure your hybrid apps are secure and performant.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/hybrid-pentest')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>API & Backend Testing</h3>
                                <p>
                                    Assess the security of the APIs and backend services that power your mobile applications.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/api-pentest')}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default MobileAppPentesting;
